





















import Vue from "vue";
import store from "../store";

export default Vue.extend({
  name: "recoveredCases",

  data: () => ({
    isLoading: true,
    recoveredCases: null
  }),

  methods: {
    fetchRecoveredCases() {
      const recoveredCases = store.getters["virusCasesFinland/recovered"];
      const recoveredCasesCount = recoveredCases.length;
      this.$data.recoveredCases = recoveredCasesCount;
      this.$data.isLoading = false;
    }
  },

  mounted() {
    this.$data.isLoading = true;

    if (
      this.$data.recoveredCases === null &&
      store.getters["virusCasesFinland/recovered"] !== null
    ) {
      this.fetchRecoveredCases();
    }

    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "virusCasesFinland/DATA_FETCHED") {
        this.fetchRecoveredCases();
      }
    });
  }
});
